import React from 'react';
import { useMedia } from 'react-use';
import DetailImage from '@/components/shoppings/DetailImage';
import { IShopping } from '@/@types/generated/contentful';

type ComponentProps = {
  shopping: IShopping;
};

const DetailImageContainer: React.FC<ComponentProps> = ({ shopping }) => {
  const isSp = useMedia('(max-width:640px)');

  return <DetailImage shopping={shopping} isSp={isSp} />;
};

export default DetailImageContainer;
